import SvgIcon from "src/components/shared/SvgIcon";

const IconRefresh = (props: any) => {
  const size = props?.size || 12;
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        height={size}
        width={size}
        {...props}
      >
        <path d="M125.7 160L176 160C193.7 160 208 174.3 208 192C208 209.7 193.7 224 176 224L48 224C30.3 224 16 209.7 16 192L16 64C16 46.3 30.3 32 48 32C65.7 32 80 46.3 80 64L80 113.5C146.6 51.7 235.6 16 320 16C440.6 16 540.4 92.1 580.7 200.8C586.2 217.4 577.2 235.4 560.6 240.9C544 246.4 526 237.4 520.5 220.8C490.5 137.1 411.2 80 320 80C254.8 80 188.3 105.5 137.8 153.2L125.7 160zM514.3 480L464 480C446.3 480 432 465.7 432 448C432 430.3 446.3 416 464 416L592 416C609.7 416 624 430.3 624 448L624 576C624 593.7 609.7 608 592 608C574.3 608 560 593.7 560 576L560 526.5C493.4 588.3 404.4 624 320 624C199.4 624 99.6 547.9 59.3 439.2C53.8 422.6 62.8 404.6 79.4 399.1C96 393.6 114 402.6 119.5 419.2C149.5 502.9 228.8 560 320 560C385.2 560 451.7 534.5 502.2 486.8L514.3 480z" />
      </svg>
    </SvgIcon>
  );
};

export default IconRefresh;
